import config from "../../custom/config";

export function linkToPhotoPage() {
  return config.PAGES.photo.path;
}
